import * as commonActionTypes from '../common/action-types'
import * as actionTypes from './action-types'
import * as mutationTypes from './mutation-types'
import { filesApi } from '../../../api/api.files'

export default {
    [actionTypes.GET_FILES_ASYNC]({ dispatch, commit }) {
        dispatch(commonActionTypes.OPEN_PENDING_CALL)
        return filesApi
            .getFiles()
            .then(r => commit(mutationTypes.FILES_UPDATED, r.data))
            .finally(() => dispatch(commonActionTypes.CLOSE_PENDING_CALL))
    },
    [actionTypes.POST_FILES_ASYNC]({ dispatch, commit }, formData) {
        commit(mutationTypes.FILES_UPLOAD_STARTED);
        return filesApi
            .uploadFiles('', formData, function (progressEvent) {
                let uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                commit(mutationTypes.UPLOAD_PROGRESS_UPDATED, uploadPercentage)
            })
            .then(r => {
                dispatch(actionTypes.GET_FILES_ASYNC, r)
                commit(mutationTypes.FILES_UPLOAD_OK)
            })
            .catch(r => {
                commit(mutationTypes.FILES_UPLOAD_ERROR, (r && r.response && r.response.data ? r.response.data : null));
            });
    },
    [actionTypes.DOWNLOAD_FILE_ASYNC]({ commit }, file) {
        return filesApi
            .downloadFile(file.id)
            .then(r => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([r.data]));
                link.setAttribute('download', file.fileName);
                document.body.appendChild(link);
                link.click();
                commit(mutationTypes.FILE_DOWNLOAD_RECEIVED);
            })
            .catch(r => {
                commit(mutationTypes.FILE_DOWNLOAD_ERROR, r.response.data);
            })
    }
}